/** The roster half of the in-memory `GameApi`: perk choices, renaming, the Hall and the classic six. */

import type { GameApi } from '../../../meta/api';
import type { PerkId, Profile, RangerRecord } from '../../../meta/types';
import { ranger } from './data';

export type RosterMethods = Pick<
  GameApi, 'choosePerk' | 'renameRanger' | 'inductVeteran' | 'retireVeteran' | 'recruitClassic' | 'retireClassic'
>;

export interface RosterDeps {
  data: Profile;
  calls: string[];
  find(id: string): RangerRecord;
  /** The fake's one id counter, shared with HQ's replacement recruits. */
  nextId(): number;
}

export function createRosterMethods({ data, calls, find, nextId }: RosterDeps): RosterMethods {
  return {
    choosePerk(rangerId, perk: PerkId) {
      calls.push('choosePerk');
      const r = find(rangerId);
      r.perks.push(perk);
      r.pendingPerkChoices.shift();
      return r;
    },
    renameRanger(rangerId, firstName, surname, callsign) {
      calls.push('renameRanger');
      return Object.assign(find(rangerId), { firstName, surname, callsign });
    },
    inductVeteran(rangerId) {
      calls.push('inductVeteran');
      if (data.hall.length >= 6) throw new Error('THE HALL OF HONOR IS FULL: RETIRE A VETERAN FIRST');
      data.hall.push({ ...find(rangerId), veteran: true });
    },
    retireVeteran(rangerId) {
      calls.push('retireVeteran');
      const r = find(rangerId);
      data.hall = data.hall.filter((v) => v.id !== rangerId);
      data.retired.push({ ...r, status: 'retired' });
    },
    recruitClassic(firstName, surname, callsign) {
      calls.push('recruitClassic');
      if (data.classicRoster.length >= 6) throw new Error('THE ROSTER IS FULL');
      const r = ranger(`c${nextId()}`, { firstName, surname, callsign, traits: [] });
      data.classicRoster.push(r);
      return r;
    },
    retireClassic(rangerId) {
      calls.push('retireClassic');
      data.classicRoster = data.classicRoster.filter((r) => r.id !== rangerId);
    },
  };
}
